import { createContext, useContext } from 'react';
import type { AxiosResponse } from 'axios';
import type { UseMutationResult } from '@tanstack/react-query';
import type { API } from '@trinity/chat';

export interface ChatUploadApiContextValue {
  usePreCheckMutation: () => UseMutationResult<
    API.Chat.FileUploadPreCheck.Response,
    AxiosResponse,
    API.Chat.FileUploadPreCheck.Request
  >;
  useUploadMutation: () => UseMutationResult<
    API.Chat.UploadFiles.Response,
    AxiosResponse,
    API.Chat.UploadFiles.Request
  >;
}

export const ChatUploadApiContext = createContext<ChatUploadApiContextValue | null>(null);

export const useChatUploadApi = () => {
  const context = useContext(ChatUploadApiContext);
  if (!context) {
    throw new Error('useChatUploadApi must be used within a ChatUploadApiProvider');
  }
  return context;
};